"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EndpointEnum;
(function (EndpointEnum) {
    EndpointEnum["AUTH"] = "auth";
    EndpointEnum["SEARCH"] = "search";
    EndpointEnum["BROWSE"] = "browse";
    EndpointEnum["AUDIT"] = "audit";
    EndpointEnum["REINDEX"] = "reindex";
})(EndpointEnum = exports.EndpointEnum || (exports.EndpointEnum = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW5kcG9pbnQuZW51bS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbnVtcy9lbmRwb2ludC5lbnVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsSUFBWSxZQU1YO0FBTkQsV0FBWSxZQUFZO0lBQ3RCLDZCQUFhLENBQUE7SUFDYixpQ0FBaUIsQ0FBQTtJQUNqQixpQ0FBaUIsQ0FBQTtJQUNqQiwrQkFBZSxDQUFBO0lBQ2YsbUNBQW1CLENBQUE7QUFDckIsQ0FBQyxFQU5XLFlBQVksR0FBWixvQkFBWSxLQUFaLG9CQUFZLFFBTXZCIn0=